import module from 'nominas/nomina/module.js'
import template from './template.html'
import { orderBy } from 'lodash'

export default class NominasNominaCalculoCalcularMotorComponent {
  idEmpresa
  idNomina
  configuracion
  onClose

  constructor ($log, NominaCalculoFactory, NominasNominaCalculoColaboradores) {
    this.$log = $log
    this.NominaCalculoFactory = NominaCalculoFactory
    this.NominasNominaCalculoColaboradores = NominasNominaCalculoColaboradores
  }

  $onInit () {
    const config = {
      calcular_viaticos: this.configuracion.calcular_viaticos,
      calcular_aguinaldo: this.configuracion.calcular_aguinaldo,
    }

    this.NominasNominaCalculoColaboradores.get(this.idEmpresa, this.idNomina, config)
      .then(({data}) => {
        const colaboradores = orderBy(data.colaboradores, ['empleado'])
        this.nominaCalculo = this.NominaCalculoFactory(colaboradores, this.configuracion)
        this.nominaCalculo.onError = (error) => (this.onError(error))
        this.nominaCalculo.onComplete = () => (this.onComplete())
        this.nominaCalculo.iniciar()
      })
  }

  $onDestroy () {
    this.terminar()
  }

  cancelar () {
    this.terminar()
    this.cerrar()
  }

  cerrar () {
    let detail = {
      resultado: (this.nominaCalculo && this.nominaCalculo.resultado) || null,
      error: (this.nominaCalculo && this.nominaCalculo.error) || null,
      completado: (this.nominaCalculo && this.nominaCalculo.completado) || false,
    }

    this.onClose({$event: {detail}})
  }

  onError (error) {
    this.$log.error(error)
    this.terminar()
  }

  onComplete () {
    this.terminar()
    this.cerrar()
  }

  terminar () {
    if (this.nominaCalculo) {
      this.nominaCalculo.cancelar()
    }
  }
}

module.component('nominasNominaCalculoCalcularMotor', {
  controller: NominasNominaCalculoCalcularMotorComponent,
  template,
  bindings: {
    idEmpresa: '<',
    idNomina: '<',
    configuracion: '<',
    onClose: '&',
  },
})



// WEBPACK FOOTER //
// ./src/nominas/nomina/components/calculo/calcular/motor/component.js